<template>
  <div class="posts-1">

    <div class="col-12 p-0 m-0 posts-1-parent-section">
      <div class="row">
        <div class="mb-5 col-lg-3 posts-1-parent-right-section" v-if="categoryPanel">

          <div class="mb-3  posts-1-banner-section-top ">
            <slot name="p-1"></slot>
          </div>


          <div class="sticky-top">
            <m-categories-panel300 link-type="blog" @category="setContentCategoryFromFilter"
                                   :flat-categories-shape="flatCategoriesShape"
                                   class=" categories-panel-300-z-index rounded rounded-4 mx-auto"/>


            <div class="mt-3  posts-1-banner-section-button ">
              <slot name="p-2"></slot>
            </div>
          </div>

        </div>

        <m-content-wrapper
            :slicer="slicer"
            :content-type="contentType"
            :category-column="`slug`"
            :content-category="contentCategories"
            :wait-for-category="waitForCategory()"
        >
          <template v-slot="{contents,pagination,changePageFunction}">

            <div :class="`col-lg-${postsSectionSize}  posts-1-parent-left-section` ">
              <div class="row ">
                <div :class="postCardClass" v-for="content in contents" :key="content.id">
                  <m-a v-if="cardLink" class="text-decoration-none posts1-card"
                       :href="{name:'SinglePost',params:{slug:content.slug}}">
                    <component :is="postCard" :content="content"/>
                  </m-a>
                  <component v-else :is="postCard" :content="content"/>
                </div>
              </div>
              <div class="row" v-if="paginate">
                <div class="col-lg-12 ">
                  <m-paginate1 :meta="pagination" :on-change-page="changePageFunction"/>
                </div>
              </div>
            </div>

          </template>
        </m-content-wrapper>

      </div>
    </div>

  </div>
</template>

<script>
import {DefaultProps} from "./DefaultProps";
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mA from "../../Tags/A";
import mH5 from "../../Tags/H5";
import mIcon from "../../Icons/Icon";
import mCategoriesPanel300 from "../../Category/Filter/FilterCategory300";
import mPaginate1 from "../../Pagination/Paginate1";
import {Cards} from '../Card/Cards'

export default {
  name: "Posts1",
  components: {...Cards, mContentWrapper, mH5, mA, mIcon, mCategoriesPanel300, mPaginate1,},
  props: DefaultProps,
  data() {
    return {
      contentCategories: null,
      categoryColumn: 'id',
    }
  },
  computed: {
    postsSectionSize() {
      if (this.categoryPanel) {
        return 9;
      }
      return 12;
    }
  },
  methods: {
    setContentCategoryFromQuery() {
      let category = this.$route.query.category;
      let categoryColumn = this.$route.query.category_column

      if (category !== undefined) {
        this.contentCategories = []
        category.split(',').forEach(item => {
          this.contentCategories.push(item)
        })
      }
      if (categoryColumn !== undefined) {
        this.categoryColumn = categoryColumn
      }
      return true
    },
    waitForCategory() {
      return this.contentCategories != null && this.contentCategories.length > 0;
    },
    setContentCategoryFromFilter(category) {
      if (category == null) {
        this.contentCategories = null
      } else {
        this.contentCategories = [category.slug]
      }
    }
  },
  beforeMount() {
    this.setContentCategoryFromQuery()
  },

}
</script>

<style scoped>
.categories-panel-300-z-index {
  z-index: 0 !important;
}

.posts1-card {
  color: var(--dark);
}
</style>